import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {EntitySchemaService} from 'app/modules/core/services/entity-schema.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class GlobalConfigResolve implements Resolve<any> {
  constructor(protected service: EntitySchemaService) {
  }

  /**
   * Loads the project-info based on a provided :projectId and returns a Observable
   */
  public resolve(route: ActivatedRouteSnapshot): Observable<any> | Promise<any> | any {
    this.service.refresh();
    const result = this.service.getSchema().map((schema) => schema).first();
    return result;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/base-app/services/global-config.resolve.ts